import { defineStore } from "pinia";
import { useRest } from "@/composables/useRest";
import { ref } from "vue";

export const useNotificationStore = defineStore("notification", () => {
  const rest = useRest();
  const pendingCount = ref(0);

  const updatePendingCount = (count) => {
    pendingCount.value = count;
  };

  const getPendientes = async (departamentalID) => {
    try {
      const search = {
        DepartamentalID: [{ operator: "=", value: departamentalID }],
      };

      const query = encodeURIComponent(JSON.stringify(search));

      const getOptions = {
        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/notificaciones/?search=${query}`,
        params: { getTotalPendientes: true },
      };

      const response = await rest.get(getOptions);

      const total = parseInt(response.data.doc?.total || 0);
      updatePendingCount(total);
      return;
    } catch (e) {
      console.error("Error al obtener pendientes:", e);
      return 0;
    }
  };

  return {
    pendingCount,
    updatePendingCount,
    getPendientes,
  };
});
